import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { VariablesService } from './../../../shared/services/variables/variables.service';
import { EventsService, PaymentService, UtilService } from '../../../shared/services';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-browse-banner',
  standalone: true,
  imports: [
    NgIf, MatButtonModule, SharedModule
  ],
  templateUrl: './browse-banner.component.html',
  styleUrls: ['./browse-banner.component.scss']
})
export class BrowseBannerComponent implements OnInit {
  @Input() subsCount: any;
  @Input() user;

  constructor(
    public vars: VariablesService,
    public paymentservice: PaymentService,
    public events: EventsService,
    private util: UtilService
  ) { }

  ngOnInit() {
    this.vars.getSubsCount();
    this.vars.subsCount.subscribe((res: any) => {
      this.subsCount = res;
    });
  }
  trackBanner() {
    this.events.sendSystemEvent({
      eventName: 'give_monthly_new',
      page_name: this.vars.pageName,
      info_1: 'position',
      info_2: 'top_banner',
      info_3: 'impact'
    }).subscribe(_ => _);
    this.util.redirectWithUTM('new/sip', { utm_term: 'browse', utm_content: 'top_banner' });
  }

}
